import axios from 'axios';
import { O_CLIENT_TYPE } from 'constants';
import { API_BASE_URL } from "constants";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'O-Client-Type': O_CLIENT_TYPE,
  },
  withCredentials: true,
});

// Add auth token to all requests dynamically
apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 errors globally
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isLoginPage = window.location.pathname.includes("/login");
      const isAuthCheck = error.config?.url?.includes("/users/me");
      if (!isLoginPage && !isAuthCheck) {
        window.location.href = "/authentication/simple/login";
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
